import { defineComponent as $, reactive as nt, computed as g, openBlock as w, createElementBlock as E, normalizeClass as ne, renderSlot as x, createElementVNode as b, createCommentVNode as j, inject as P, provide as B, createTextVNode as ot, toDisplayString as _e, watchEffect as N, ref as h, cloneVNode as Lt, h as S, Fragment as Se, onMounted as L, onUnmounted as M, watch as oe, shallowRef as Pt, unref as U, getCurrentInstance as Ot, Teleport as at, nextTick as Ft, createBlock as lt, withCtx as re, createVNode as K, onBeforeUnmount as Dt, Transition as At, renderList as Ct } from "vue";
const Nt = ["disabled"], jt = /* @__PURE__ */ $({
  __name: "TEButton",
  props: {
    primary: { type: Boolean },
    disabled: { type: Boolean },
    color: {}
  },
  setup(e) {
    const t = e, { primary: r, disabled: n, color: o } = nt(t), a = {
      zinc: "bg-zinc-500 dark:bg-zinc-800 hover:bg-zinc-600 focus:bg-zinc-600 hover:bg-zinc-600 focus:bg-zinc-600 active:bg-zinc-700 hover:dark:bg-zinc-700",
      red: "bg-red-500 dark:bg-red-800 hover:bg-red-600 focus:bg-red-600 hover:bg-red-600 focus:bg-red-600 active:bg-red-700 hover:dark:bg-red-700",
      orange: "bg-orange-500 dark:bg-orange-800 hover:bg-orange-600 focus:bg-orange-600 hover:bg-orange-600 focus:bg-orange-600 active:bg-orange-700 hover:dark:bg-orange-700",
      yellow: "bg-yellow-500 dark:bg-yellow-800 hover:bg-yellow-600 focus:bg-yellow-600 hover:bg-yellow-600 focus:bg-yellow-600 active:bg-yellow-700 hover:dark:bg-yellow-700",
      green: "bg-green-500 dark:bg-green-800 hover:bg-green-600 focus:bg-green-600 hover:bg-green-600 focus:bg-green-600 active:bg-green-700 hover:dark:bg-green-700",
      teal: "bg-teal-500 dark:bg-teal-800 hover:bg-teal-600 focus:bg-teal-600 hover:bg-teal-600 focus:bg-teal-600 active:bg-teal-700 hover:dark:bg-teal-700",
      blue: "bg-blue-500 dark:bg-blue-800 hover:bg-blue-600 focus:bg-blue-600 hover:bg-blue-600 focus:bg-blue-600 active:bg-blue-700 hover:dark:bg-blue-700",
      sky: "bg-sky-500 dark:bg-sky-800 hover:bg-sky-600 focus:bg-sky-600 hover:bg-sky-600 focus:bg-sky-600 active:bg-sky-700 hover:dark:bg-sky-700",
      indigo: "bg-indigo-500 dark:bg-indigo-800 hover:bg-indigo-600 focus:bg-indigo-600 hover:bg-indigo-600 focus:bg-indigo-600 active:bg-indigo-700 hover:dark:bg-indigo-700",
      purple: "bg-purple-500 dark:bg-purple-800 hover:bg-purple-600 focus:bg-purple-600 hover:bg-purple-600 focus:bg-purple-600 active:bg-purple-700 hover:dark:bg-purple-700",
      pink: "bg-pink-500 dark:bg-pink-800 hover:bg-pink-600 focus:bg-pink-600 hover:bg-pink-600 focus:bg-pink-600 active:bg-pink-700 hover:dark:bg-pink-700",
      primary: "bg-primary-500 dark:bg-primary-800 hover:bg-primary-600 focus:bg-primary-600 hover:bg-primary-600 focus:bg-primary-600 active:bg-primary-700 hover:dark:bg-primary-700",
      accent: "bg-accent-500 dark:bg-accent-800 hover:bg-accent-600 focus:bg-accent-600 hover:bg-accent-600 focus:bg-accent-600 active:bg-accent-700 hover:dark:bg-accent-700",
      rose: "bg-rose-500 dark:bg-rose-800 hover:bg-rose-600 focus:bg-rose-600 hover:bg-rose-600 focus:bg-rose-600 active:bg-rose-700 hover:dark:bg-rose-700",
      emerald: "bg-emerald-500 dark:bg-emerald-800 hover:bg-emerald-600 focus:bg-emerald-600 hover:bg-emerald-600 focus:bg-emerald-600 active:bg-emerald-700 hover:dark:bg-emerald-700"
    }, l = g(() => a[o ?? "primary"]);
    return (i, s) => (w(), E("button", {
      type: "button",
      disabled: t.disabled,
      class: ne([t.disabled ? "cursor-not-allowed bg-gray-500" : l.value, "inline-block rounded-full px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-white transition duration-150 ease-in-out focus:outline-none focus:ring-0"])
    }, [
      x(i.$slots, "default")
    ], 10, Nt));
  }
}), de = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [n, o] of t)
    r[n] = o;
  return r;
}, Bt = {}, Mt = { class: "flex w-full justify-center" }, Ht = { class: "max-w-8xl w-full rounded bg-white p-4 shadow dark:border-primary-400 dark:bg-zinc-800" }, zt = {
  key: 0,
  class: "-mx-4 -mb-4 mt-5 border-t-2 bg-gray-50 px-4 pb-4 dark:border-zinc-700 dark:bg-zinc-900"
}, Rt = { class: "flex justify-end pt-4" };
function It(e, t) {
  return w(), E("div", Mt, [
    b("div", Ht, [
      x(e.$slots, "default"),
      e.$slots.actions ? (w(), E("div", zt, [
        b("div", Rt, [
          x(e.$slots, "actions")
        ])
      ])) : j("", !0)
    ])
  ]);
}
const Vt = /* @__PURE__ */ de(Bt, [["render", It]]), Ut = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Vt
}, Symbol.toStringTag, { value: "Module" })), Wt = ["id", "value", "type", "placeholder"], eo = /* @__PURE__ */ $({
  __name: "TETextInput",
  props: {
    name: {},
    placeholder: {},
    required: { type: Boolean },
    type: {},
    modelValue: {},
    error: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, n = t;
    function o(i) {
      const s = i.target;
      n("update:modelValue", s.value);
    }
    const a = g(() => P(`error-${r.name}`)), l = g(() => a.value.value ? "border-red-500" : "border-gray-400");
    return (i, s) => (w(), E("input", {
      id: i.name,
      value: i.modelValue,
      type: i.type ?? "text",
      placeholder: i.placeholder,
      class: ne(["block w-full rounded-md border-0 px-2 py-1.5 text-gray-900 outline-0 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:outline-0 focus:ring-2 focus:ring-inset focus:ring-primary-600 focus:transition-all sm:text-sm sm:leading-6 dark:bg-zinc-600 dark:text-white dark:ring-zinc-900 focus:dark:ring-primary-900", l.value]),
      onInput: o
    }, null, 42, Wt));
  }
}), qt = { class: "py-2" }, Gt = ["for"], Yt = {
  key: 0,
  class: "text-red-500"
}, Kt = { class: "" }, Xt = {
  key: 0,
  class: "text-sm text-red-600"
}, to = /* @__PURE__ */ $({
  __name: "TETopLabelLayout",
  props: {
    title: {},
    required: { type: Boolean },
    name: {},
    error: {}
  },
  setup(e) {
    const t = e, r = g(() => t.error ?? void 0);
    return B(
      `error-${t.name}`,
      g(() => r.value ?? void 0)
    ), (n, o) => (w(), E("div", qt, [
      b("label", {
        for: n.name,
        class: "block text-sm font-medium leading-6 text-gray-900 dark:text-gray-300"
      }, [
        ot(_e(n.title), 1),
        n.required ? (w(), E("span", Yt, "*")) : j("", !0)
      ], 8, Gt),
      b("div", Kt, [
        x(n.$slots, "default", { class: "block w-full" })
      ]),
      r.value ? (w(), E("div", Xt, _e(r.value), 1)) : j("", !0)
    ]));
  }
}), ro = /* @__PURE__ */ $({
  __name: "TEBadge",
  props: {
    type: {}
  },
  setup(e) {
    const t = e, r = {
      white: "bg-zinc-200/40 text-zinc-800 border-zinc-300 dark:border-zinc-700 dark:bg-zinc-700/50 dark:text-zinc-200",
      accent: "bg-accent-200/40 text-accent-800 border-accent-300 dark:border-accent-700 dark:bg-accent-700/50 dark:text-accent-200",
      red: "bg-red-200/40 text-red-800 border-red-300 dark:border-red-700 dark:bg-red-900/50 dark:border-red-900 dark:text-red-500",
      orange: "bg-orange-200/40 text-orange-800 border-orange-300 dark:border-orange-700 dark:bg-orange-900/50 dark:text-orange-500",
      yellow: "bg-yellow-200/40 text-yellow-800 border-yellow-300 dark:border-yellow-700 dark:bg-yellow-900/50 dark:text-yellow-500",
      green: "bg-green-200/40 text-green-800 border-green-300 dark:border-green-700 dark:bg-green-900/50 dark:text-green-500",
      teal: "bg-teal-200/40 text-teal-800 border-teal-300 dark:border-teal-700 dark:bg-teal-900/50 dark:text-teal-500",
      blue: "bg-blue-200/40 text-blue-800 border-blue-300 dark:border-blue-700 dark:bg-blue-900/50 dark:text-blue-500",
      sky: "bg-sky-200/40 text-sky-800 border-sky-300 dark:border-sky-700 dark:bg-sky-900/50 dark:text-sky-500",
      indigo: "bg-indigo-200/40 text-indigo-800 border-indigo-300 dark:border-indigo-700 dark:bg-indigo-900/60 dark:text-indigo-400",
      purple: "bg-purple-200/40 text-purple-800 border-purple-300 dark:border-purple-700 dark:bg-purple-900/60 dark:text-purple-400",
      pink: "bg-pink-200/40 text-pink-800 border-pink-300 dark:border-pink-700 dark:bg-pink-900/50 dark:text-pink-500",
      primary: "bg-primary-200/40 text-primary-800 border-primary-300 dark:border-primary-700 dark:bg-primary-900/50 dark:text-primary-500",
      rose: "bg-rose-200/40 text-rose-800 border-rose-300 dark:border-rose-700 dark:bg-rose-900/50 dark:text-rose-500",
      emerald: "bg-emerald-200/40 text-emerald-800 border-emerald-300 dark:border-emerald-700 dark:bg-emerald-900/50 dark:text-emerald-500"
    }, n = g(() => r[t.type]);
    return (o, a) => (w(), E("span", {
      class: ne([n.value, "rounded-full p-1 px-2"])
    }, [
      x(o.$slots, "default")
    ], 2));
  }
});
function We(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((t) => setTimeout(() => {
    throw t;
  }));
}
function ce() {
  let e = [], t = { addEventListener(r, n, o, a) {
    return r.addEventListener(n, o, a), t.add(() => r.removeEventListener(n, o, a));
  }, requestAnimationFrame(...r) {
    let n = requestAnimationFrame(...r);
    t.add(() => cancelAnimationFrame(n));
  }, nextFrame(...r) {
    t.requestAnimationFrame(() => {
      t.requestAnimationFrame(...r);
    });
  }, setTimeout(...r) {
    let n = setTimeout(...r);
    t.add(() => clearTimeout(n));
  }, microTask(...r) {
    let n = { current: !0 };
    return We(() => {
      n.current && r[0]();
    }), t.add(() => {
      n.current = !1;
    });
  }, style(r, n, o) {
    let a = r.style.getPropertyValue(n);
    return Object.assign(r.style, { [n]: o }), this.add(() => {
      Object.assign(r.style, { [n]: a });
    });
  }, group(r) {
    let n = ce();
    return r(n), this.add(() => n.dispose());
  }, add(r) {
    return e.push(r), () => {
      let n = e.indexOf(r);
      if (n >= 0) for (let o of e.splice(n, 1)) o();
    };
  }, dispose() {
    for (let r of e.splice(0)) r();
  } };
  return t;
}
let Qt = Symbol("headlessui.useid"), Zt = 0;
function J() {
  return P(Qt, () => `${++Zt}`)();
}
function T(e) {
  var t;
  if (e == null || e.value == null) return null;
  let r = (t = e.value.$el) != null ? t : e.value;
  return r instanceof Node ? r : null;
}
function R(e, t, ...r) {
  if (e in t) {
    let o = t[e];
    return typeof o == "function" ? o(...r) : o;
  }
  let n = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((o) => `"${o}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(n, R), n;
}
var Jt = Object.defineProperty, er = (e, t, r) => t in e ? Jt(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, Ze = (e, t, r) => (er(e, typeof t != "symbol" ? t + "" : t, r), r);
let tr = class {
  constructor() {
    Ze(this, "current", this.detect()), Ze(this, "currentId", 0);
  }
  set(t) {
    this.current !== t && (this.currentId = 0, this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}, pe = new tr();
function ae(e) {
  if (pe.isServer) return null;
  if (e instanceof Node) return e.ownerDocument;
  if (e != null && e.hasOwnProperty("value")) {
    let t = T(e);
    if (t) return t.ownerDocument;
  }
  return document;
}
let je = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var W = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(W || {}), it = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(it || {}), rr = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(rr || {});
function nr(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(je)).sort((t, r) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (r.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var st = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(st || {});
function or(e, t = 0) {
  var r;
  return e === ((r = ae(e)) == null ? void 0 : r.body) ? !1 : R(t, { 0() {
    return e.matches(je);
  }, 1() {
    let n = e;
    for (; n !== null; ) {
      if (n.matches(je)) return !0;
      n = n.parentElement;
    }
    return !1;
  } });
}
var ar = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(ar || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function Z(e) {
  e == null || e.focus({ preventScroll: !0 });
}
let lr = ["textarea", "input"].join(",");
function ir(e) {
  var t, r;
  return (r = (t = e == null ? void 0 : e.matches) == null ? void 0 : t.call(e, lr)) != null ? r : !1;
}
function sr(e, t = (r) => r) {
  return e.slice().sort((r, n) => {
    let o = t(r), a = t(n);
    if (o === null || a === null) return 0;
    let l = o.compareDocumentPosition(a);
    return l & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : l & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function $e(e, t, { sorted: r = !0, relativeTo: n = null, skipElements: o = [] } = {}) {
  var a;
  let l = (a = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e == null ? void 0 : e.ownerDocument) != null ? a : document, i = Array.isArray(e) ? r ? sr(e) : e : nr(e);
  o.length > 0 && i.length > 1 && (i = i.filter((p) => !o.includes(p))), n = n ?? l.activeElement;
  let s = (() => {
    if (t & 5) return 1;
    if (t & 10) return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), u = (() => {
    if (t & 1) return 0;
    if (t & 2) return Math.max(0, i.indexOf(n)) - 1;
    if (t & 4) return Math.max(0, i.indexOf(n)) + 1;
    if (t & 8) return i.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), d = t & 32 ? { preventScroll: !0 } : {}, v = 0, c = i.length, f;
  do {
    if (v >= c || v + c <= 0) return 0;
    let p = u + v;
    if (t & 16) p = (p + c) % c;
    else {
      if (p < 0) return 3;
      if (p >= c) return 1;
    }
    f = i[p], f == null || f.focus(d), v += s;
  } while (f !== l.activeElement);
  return t & 6 && ir(f) && f.select(), 2;
}
function ut() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function ur() {
  return /Android/gi.test(window.navigator.userAgent);
}
function dr() {
  return ut() || ur();
}
function we(e, t, r) {
  pe.isServer || N((n) => {
    document.addEventListener(e, t, r), n(() => document.removeEventListener(e, t, r));
  });
}
function dt(e, t, r) {
  pe.isServer || N((n) => {
    window.addEventListener(e, t, r), n(() => window.removeEventListener(e, t, r));
  });
}
function cr(e, t, r = g(() => !0)) {
  function n(a, l) {
    if (!r.value || a.defaultPrevented) return;
    let i = l(a);
    if (i === null || !i.getRootNode().contains(i)) return;
    let s = function u(d) {
      return typeof d == "function" ? u(d()) : Array.isArray(d) || d instanceof Set ? d : [d];
    }(e);
    for (let u of s) {
      if (u === null) continue;
      let d = u instanceof HTMLElement ? u : T(u);
      if (d != null && d.contains(i) || a.composed && a.composedPath().includes(d)) return;
    }
    return !or(i, st.Loose) && i.tabIndex !== -1 && a.preventDefault(), t(a, i);
  }
  let o = h(null);
  we("pointerdown", (a) => {
    var l, i;
    r.value && (o.value = ((i = (l = a.composedPath) == null ? void 0 : l.call(a)) == null ? void 0 : i[0]) || a.target);
  }, !0), we("mousedown", (a) => {
    var l, i;
    r.value && (o.value = ((i = (l = a.composedPath) == null ? void 0 : l.call(a)) == null ? void 0 : i[0]) || a.target);
  }, !0), we("click", (a) => {
    dr() || o.value && (n(a, () => o.value), o.value = null);
  }, !0), we("touchend", (a) => n(a, () => a.target instanceof HTMLElement ? a.target : null), !0), dt("blur", (a) => n(a, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
var Te = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(Te || {}), q = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(q || {});
function D({ visible: e = !0, features: t = 0, ourProps: r, theirProps: n, ...o }) {
  var a;
  let l = pt(n, r), i = Object.assign(o, { props: l });
  if (e || t & 2 && l.static) return Ae(i);
  if (t & 1) {
    let s = (a = l.unmount) == null || a ? 0 : 1;
    return R(s, { 0() {
      return null;
    }, 1() {
      return Ae({ ...o, props: { ...l, hidden: !0, style: { display: "none" } } });
    } });
  }
  return Ae(i);
}
function Ae({ props: e, attrs: t, slots: r, slot: n, name: o }) {
  var a, l;
  let { as: i, ...s } = ft(e, ["unmount", "static"]), u = (a = r.default) == null ? void 0 : a.call(r, n), d = {};
  if (n) {
    let v = !1, c = [];
    for (let [f, p] of Object.entries(n)) typeof p == "boolean" && (v = !0), p === !0 && c.push(f);
    v && (d["data-headlessui-state"] = c.join(" "));
  }
  if (i === "template") {
    if (u = ct(u ?? []), Object.keys(s).length > 0 || Object.keys(t).length > 0) {
      let [v, ...c] = u ?? [];
      if (!pr(v) || c.length > 0) throw new Error(['Passing props on "template"!', "", `The current component <${o} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(s).concat(Object.keys(t)).map((m) => m.trim()).filter((m, k, H) => H.indexOf(m) === k).sort((m, k) => m.localeCompare(k)).map((m) => `  - ${m}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((m) => `  - ${m}`).join(`
`)].join(`
`));
      let f = pt((l = v.props) != null ? l : {}, s, d), p = Lt(v, f, !0);
      for (let m in f) m.startsWith("on") && (p.props || (p.props = {}), p.props[m] = f[m]);
      return p;
    }
    return Array.isArray(u) && u.length === 1 ? u[0] : u;
  }
  return S(i, Object.assign({}, s, d), { default: () => u });
}
function ct(e) {
  return e.flatMap((t) => t.type === Se ? ct(t.children) : [t]);
}
function pt(...e) {
  if (e.length === 0) return {};
  if (e.length === 1) return e[0];
  let t = {}, r = {};
  for (let n of e) for (let o in n) o.startsWith("on") && typeof n[o] == "function" ? (r[o] != null || (r[o] = []), r[o].push(n[o])) : t[o] = n[o];
  if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(r).map((n) => [n, void 0])));
  for (let n in r) Object.assign(t, { [n](o, ...a) {
    let l = r[n];
    for (let i of l) {
      if (o instanceof Event && o.defaultPrevented) return;
      i(o, ...a);
    }
  } });
  return t;
}
function ft(e, t = []) {
  let r = Object.assign({}, e);
  for (let n of t) n in r && delete r[n];
  return r;
}
function pr(e) {
  return e == null ? !1 : typeof e.type == "string" || typeof e.type == "object" || typeof e.type == "function";
}
var xe = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(xe || {});
let Be = $({ name: "Hidden", props: { as: { type: [Object, String], default: "div" }, features: { type: Number, default: 1 } }, setup(e, { slots: t, attrs: r }) {
  return () => {
    var n;
    let { features: o, ...a } = e, l = { "aria-hidden": (o & 2) === 2 ? !0 : (n = a["aria-hidden"]) != null ? n : void 0, hidden: (o & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(o & 4) === 4 && (o & 2) !== 2 && { display: "none" } } };
    return D({ ourProps: l, theirProps: a, slot: {}, attrs: r, slots: t, name: "Hidden" });
  };
} }), gt = Symbol("Context");
var F = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(F || {});
function fr() {
  return qe() !== null;
}
function qe() {
  return P(gt, null);
}
function gr(e) {
  B(gt, e);
}
var vt = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(vt || {});
function vr(e) {
  function t() {
    document.readyState !== "loading" && (e(), document.removeEventListener("DOMContentLoaded", t));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", t), t());
}
let X = [];
vr(() => {
  function e(t) {
    t.target instanceof HTMLElement && t.target !== document.body && X[0] !== t.target && (X.unshift(t.target), X = X.filter((r) => r != null && r.isConnected), X.splice(10));
  }
  window.addEventListener("click", e, { capture: !0 }), window.addEventListener("mousedown", e, { capture: !0 }), window.addEventListener("focus", e, { capture: !0 }), document.body.addEventListener("click", e, { capture: !0 }), document.body.addEventListener("mousedown", e, { capture: !0 }), document.body.addEventListener("focus", e, { capture: !0 });
});
function mt(e, t, r, n) {
  pe.isServer || N((o) => {
    e = e ?? window, e.addEventListener(t, r, n), o(() => e.removeEventListener(t, r, n));
  });
}
var ue = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(ue || {});
function mr() {
  let e = h(0);
  return dt("keydown", (t) => {
    t.key === "Tab" && (e.value = t.shiftKey ? 1 : 0);
  }), e;
}
function bt(e) {
  if (!e) return /* @__PURE__ */ new Set();
  if (typeof e == "function") return new Set(e());
  let t = /* @__PURE__ */ new Set();
  for (let r of e.value) {
    let n = T(r);
    n instanceof HTMLElement && t.add(n);
  }
  return t;
}
var ht = ((e) => (e[e.None = 1] = "None", e[e.InitialFocus = 2] = "InitialFocus", e[e.TabLock = 4] = "TabLock", e[e.FocusLock = 8] = "FocusLock", e[e.RestoreFocus = 16] = "RestoreFocus", e[e.All = 30] = "All", e))(ht || {});
let ie = Object.assign($({ name: "FocusTrap", props: { as: { type: [Object, String], default: "div" }, initialFocus: { type: Object, default: null }, features: { type: Number, default: 30 }, containers: { type: [Object, Function], default: h(/* @__PURE__ */ new Set()) } }, inheritAttrs: !1, setup(e, { attrs: t, slots: r, expose: n }) {
  let o = h(null);
  n({ el: o, $el: o });
  let a = g(() => ae(o)), l = h(!1);
  L(() => l.value = !0), M(() => l.value = !1), hr({ ownerDocument: a }, g(() => l.value && !!(e.features & 16)));
  let i = yr({ ownerDocument: a, container: o, initialFocus: g(() => e.initialFocus) }, g(() => l.value && !!(e.features & 2)));
  wr({ ownerDocument: a, container: o, containers: e.containers, previousActiveElement: i }, g(() => l.value && !!(e.features & 8)));
  let s = mr();
  function u(f) {
    let p = T(o);
    p && ((m) => m())(() => {
      R(s.value, { [ue.Forwards]: () => {
        $e(p, W.First, { skipElements: [f.relatedTarget] });
      }, [ue.Backwards]: () => {
        $e(p, W.Last, { skipElements: [f.relatedTarget] });
      } });
    });
  }
  let d = h(!1);
  function v(f) {
    f.key === "Tab" && (d.value = !0, requestAnimationFrame(() => {
      d.value = !1;
    }));
  }
  function c(f) {
    if (!l.value) return;
    let p = bt(e.containers);
    T(o) instanceof HTMLElement && p.add(T(o));
    let m = f.relatedTarget;
    m instanceof HTMLElement && m.dataset.headlessuiFocusGuard !== "true" && (yt(p, m) || (d.value ? $e(T(o), R(s.value, { [ue.Forwards]: () => W.Next, [ue.Backwards]: () => W.Previous }) | W.WrapAround, { relativeTo: f.target }) : f.target instanceof HTMLElement && Z(f.target)));
  }
  return () => {
    let f = {}, p = { ref: o, onKeydown: v, onFocusout: c }, { features: m, initialFocus: k, containers: H, ...O } = e;
    return S(Se, [!!(m & 4) && S(Be, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: u, features: xe.Focusable }), D({ ourProps: p, theirProps: { ...t, ...O }, slot: f, attrs: t, slots: r, name: "FocusTrap" }), !!(m & 4) && S(Be, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: u, features: xe.Focusable })]);
  };
} }), { features: ht });
function br(e) {
  let t = h(X.slice());
  return oe([e], ([r], [n]) => {
    n === !0 && r === !1 ? We(() => {
      t.value.splice(0);
    }) : n === !1 && r === !0 && (t.value = X.slice());
  }, { flush: "post" }), () => {
    var r;
    return (r = t.value.find((n) => n != null && n.isConnected)) != null ? r : null;
  };
}
function hr({ ownerDocument: e }, t) {
  let r = br(t);
  L(() => {
    N(() => {
      var n, o;
      t.value || ((n = e.value) == null ? void 0 : n.activeElement) === ((o = e.value) == null ? void 0 : o.body) && Z(r());
    }, { flush: "post" });
  }), M(() => {
    t.value && Z(r());
  });
}
function yr({ ownerDocument: e, container: t, initialFocus: r }, n) {
  let o = h(null), a = h(!1);
  return L(() => a.value = !0), M(() => a.value = !1), L(() => {
    oe([t, r, n], (l, i) => {
      if (l.every((u, d) => (i == null ? void 0 : i[d]) === u) || !n.value) return;
      let s = T(t);
      s && We(() => {
        var u, d;
        if (!a.value) return;
        let v = T(r), c = (u = e.value) == null ? void 0 : u.activeElement;
        if (v) {
          if (v === c) {
            o.value = c;
            return;
          }
        } else if (s.contains(c)) {
          o.value = c;
          return;
        }
        v ? Z(v) : $e(s, W.First | W.NoScroll) === it.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), o.value = (d = e.value) == null ? void 0 : d.activeElement;
      });
    }, { immediate: !0, flush: "post" });
  }), o;
}
function wr({ ownerDocument: e, container: t, containers: r, previousActiveElement: n }, o) {
  var a;
  mt((a = e.value) == null ? void 0 : a.defaultView, "focus", (l) => {
    if (!o.value) return;
    let i = bt(r);
    T(t) instanceof HTMLElement && i.add(T(t));
    let s = n.value;
    if (!s) return;
    let u = l.target;
    u && u instanceof HTMLElement ? yt(i, u) ? (n.value = u, Z(u)) : (l.preventDefault(), l.stopPropagation(), Z(s)) : Z(n.value);
  }, !0);
}
function yt(e, t) {
  for (let r of e) if (r.contains(t)) return !0;
  return !1;
}
function kr(e) {
  let t = Pt(e.getSnapshot());
  return M(e.subscribe(() => {
    t.value = e.getSnapshot();
  })), t;
}
function Er(e, t) {
  let r = e(), n = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return r;
  }, subscribe(o) {
    return n.add(o), () => n.delete(o);
  }, dispatch(o, ...a) {
    let l = t[o].call(r, ...a);
    l && (r = l, n.forEach((i) => i()));
  } };
}
function $r() {
  let e;
  return { before({ doc: t }) {
    var r;
    let n = t.documentElement;
    e = ((r = t.defaultView) != null ? r : window).innerWidth - n.clientWidth;
  }, after({ doc: t, d: r }) {
    let n = t.documentElement, o = n.clientWidth - n.offsetWidth, a = e - o;
    r.style(n, "paddingRight", `${a}px`);
  } };
}
function _r() {
  return ut() ? { before({ doc: e, d: t, meta: r }) {
    function n(o) {
      return r.containers.flatMap((a) => a()).some((a) => a.contains(o));
    }
    t.microTask(() => {
      var o;
      if (window.getComputedStyle(e.documentElement).scrollBehavior !== "auto") {
        let i = ce();
        i.style(e.documentElement, "scrollBehavior", "auto"), t.add(() => t.microTask(() => i.dispose()));
      }
      let a = (o = window.scrollY) != null ? o : window.pageYOffset, l = null;
      t.addEventListener(e, "click", (i) => {
        if (i.target instanceof HTMLElement) try {
          let s = i.target.closest("a");
          if (!s) return;
          let { hash: u } = new URL(s.href), d = e.querySelector(u);
          d && !n(d) && (l = d);
        } catch {
        }
      }, !0), t.addEventListener(e, "touchstart", (i) => {
        if (i.target instanceof HTMLElement) if (n(i.target)) {
          let s = i.target;
          for (; s.parentElement && n(s.parentElement); ) s = s.parentElement;
          t.style(s, "overscrollBehavior", "contain");
        } else t.style(i.target, "touchAction", "none");
      }), t.addEventListener(e, "touchmove", (i) => {
        if (i.target instanceof HTMLElement) {
          if (i.target.tagName === "INPUT") return;
          if (n(i.target)) {
            let s = i.target;
            for (; s.parentElement && s.dataset.headlessuiPortal !== "" && !(s.scrollHeight > s.clientHeight || s.scrollWidth > s.clientWidth); ) s = s.parentElement;
            s.dataset.headlessuiPortal === "" && i.preventDefault();
          } else i.preventDefault();
        }
      }, { passive: !1 }), t.add(() => {
        var i;
        let s = (i = window.scrollY) != null ? i : window.pageYOffset;
        a !== s && window.scrollTo(0, a), l && l.isConnected && (l.scrollIntoView({ block: "nearest" }), l = null);
      });
    });
  } } : {};
}
function Tr() {
  return { before({ doc: e, d: t }) {
    t.style(e.documentElement, "overflow", "hidden");
  } };
}
function xr(e) {
  let t = {};
  for (let r of e) Object.assign(t, r(t));
  return t;
}
let Q = Er(() => /* @__PURE__ */ new Map(), { PUSH(e, t) {
  var r;
  let n = (r = this.get(e)) != null ? r : { doc: e, count: 0, d: ce(), meta: /* @__PURE__ */ new Set() };
  return n.count++, n.meta.add(t), this.set(e, n), this;
}, POP(e, t) {
  let r = this.get(e);
  return r && (r.count--, r.meta.delete(t)), this;
}, SCROLL_PREVENT({ doc: e, d: t, meta: r }) {
  let n = { doc: e, d: t, meta: xr(r) }, o = [_r(), $r(), Tr()];
  o.forEach(({ before: a }) => a == null ? void 0 : a(n)), o.forEach(({ after: a }) => a == null ? void 0 : a(n));
}, SCROLL_ALLOW({ d: e }) {
  e.dispose();
}, TEARDOWN({ doc: e }) {
  this.delete(e);
} });
Q.subscribe(() => {
  let e = Q.getSnapshot(), t = /* @__PURE__ */ new Map();
  for (let [r] of e) t.set(r, r.documentElement.style.overflow);
  for (let r of e.values()) {
    let n = t.get(r.doc) === "hidden", o = r.count !== 0;
    (o && !n || !o && n) && Q.dispatch(r.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", r), r.count === 0 && Q.dispatch("TEARDOWN", r);
  }
});
function Sr(e, t, r) {
  let n = kr(Q), o = g(() => {
    let a = e.value ? n.value.get(e.value) : void 0;
    return a ? a.count > 0 : !1;
  });
  return oe([e, t], ([a, l], [i], s) => {
    if (!a || !l) return;
    Q.dispatch("PUSH", a, r);
    let u = !1;
    s(() => {
      u || (Q.dispatch("POP", i ?? a, r), u = !0);
    });
  }, { immediate: !0 }), o;
}
let Ce = /* @__PURE__ */ new Map(), se = /* @__PURE__ */ new Map();
function Je(e, t = h(!0)) {
  N((r) => {
    var n;
    if (!t.value) return;
    let o = T(e);
    if (!o) return;
    r(function() {
      var l;
      if (!o) return;
      let i = (l = se.get(o)) != null ? l : 1;
      if (i === 1 ? se.delete(o) : se.set(o, i - 1), i !== 1) return;
      let s = Ce.get(o);
      s && (s["aria-hidden"] === null ? o.removeAttribute("aria-hidden") : o.setAttribute("aria-hidden", s["aria-hidden"]), o.inert = s.inert, Ce.delete(o));
    });
    let a = (n = se.get(o)) != null ? n : 0;
    se.set(o, a + 1), a === 0 && (Ce.set(o, { "aria-hidden": o.getAttribute("aria-hidden"), inert: o.inert }), o.setAttribute("aria-hidden", "true"), o.inert = !0);
  });
}
function Lr({ defaultContainers: e = [], portals: t, mainTreeNodeRef: r } = {}) {
  let n = h(null), o = ae(n);
  function a() {
    var l, i, s;
    let u = [];
    for (let d of e) d !== null && (d instanceof HTMLElement ? u.push(d) : "value" in d && d.value instanceof HTMLElement && u.push(d.value));
    if (t != null && t.value) for (let d of t.value) u.push(d);
    for (let d of (l = o == null ? void 0 : o.querySelectorAll("html > *, body > *")) != null ? l : []) d !== document.body && d !== document.head && d instanceof HTMLElement && d.id !== "headlessui-portal-root" && (d.contains(T(n)) || d.contains((s = (i = T(n)) == null ? void 0 : i.getRootNode()) == null ? void 0 : s.host) || u.some((v) => d.contains(v)) || u.push(d));
    return u;
  }
  return { resolveContainers: a, contains(l) {
    return a().some((i) => i.contains(l));
  }, mainTreeNodeRef: n, MainTreeNode() {
    return r != null ? null : S(Be, { features: xe.Hidden, ref: n });
  } };
}
let wt = Symbol("ForcePortalRootContext");
function Pr() {
  return P(wt, !1);
}
let Me = $({ name: "ForcePortalRoot", props: { as: { type: [Object, String], default: "template" }, force: { type: Boolean, default: !1 } }, setup(e, { slots: t, attrs: r }) {
  return B(wt, e.force), () => {
    let { force: n, ...o } = e;
    return D({ theirProps: o, ourProps: {}, slot: {}, slots: t, attrs: r, name: "ForcePortalRoot" });
  };
} }), kt = Symbol("StackContext");
var He = ((e) => (e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))(He || {});
function Or() {
  return P(kt, () => {
  });
}
function Fr({ type: e, enabled: t, element: r, onUpdate: n }) {
  let o = Or();
  function a(...l) {
    n == null || n(...l), o(...l);
  }
  L(() => {
    oe(t, (l, i) => {
      l ? a(0, e, r) : i === !0 && a(1, e, r);
    }, { immediate: !0, flush: "sync" });
  }), M(() => {
    t.value && a(1, e, r);
  }), B(kt, a);
}
let Et = Symbol("DescriptionContext");
function Dr() {
  let e = P(Et, null);
  if (e === null) throw new Error("Missing parent");
  return e;
}
function Ar({ slot: e = h({}), name: t = "Description", props: r = {} } = {}) {
  let n = h([]);
  function o(a) {
    return n.value.push(a), () => {
      let l = n.value.indexOf(a);
      l !== -1 && n.value.splice(l, 1);
    };
  }
  return B(Et, { register: o, slot: e, name: t, props: r }), g(() => n.value.length > 0 ? n.value.join(" ") : void 0);
}
$({ name: "Description", props: { as: { type: [Object, String], default: "p" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r }) {
  var n;
  let o = (n = e.id) != null ? n : `headlessui-description-${J()}`, a = Dr();
  return L(() => M(a.register(o))), () => {
    let { name: l = "Description", slot: i = h({}), props: s = {} } = a, { ...u } = e, d = { ...Object.entries(s).reduce((v, [c, f]) => Object.assign(v, { [c]: U(f) }), {}), id: o };
    return D({ ourProps: d, theirProps: u, slot: i.value, attrs: t, slots: r, name: l });
  };
} });
function Cr(e) {
  let t = ae(e);
  if (!t) {
    if (e === null) return null;
    throw new Error(`[Headless UI]: Cannot find ownerDocument for contextElement: ${e}`);
  }
  let r = t.getElementById("headlessui-portal-root");
  if (r) return r;
  let n = t.createElement("div");
  return n.setAttribute("id", "headlessui-portal-root"), t.body.appendChild(n);
}
const ze = /* @__PURE__ */ new WeakMap();
function Nr(e) {
  var t;
  return (t = ze.get(e)) != null ? t : 0;
}
function et(e, t) {
  let r = t(Nr(e));
  return r <= 0 ? ze.delete(e) : ze.set(e, r), r;
}
let $t = $({ name: "Portal", props: { as: { type: [Object, String], default: "div" } }, setup(e, { slots: t, attrs: r }) {
  let n = h(null), o = g(() => ae(n)), a = Pr(), l = P(_t, null), i = h(a === !0 || l == null ? Cr(n.value) : l.resolveTarget());
  i.value && et(i.value, (c) => c + 1);
  let s = h(!1);
  L(() => {
    s.value = !0;
  }), N(() => {
    a || l != null && (i.value = l.resolveTarget());
  });
  let u = P(Re, null), d = !1, v = Ot();
  return oe(n, () => {
    if (d || !u) return;
    let c = T(n);
    c && (M(u.register(c), v), d = !0);
  }), M(() => {
    var c, f;
    let p = (c = o.value) == null ? void 0 : c.getElementById("headlessui-portal-root");
    !p || i.value !== p || et(i.value, (m) => m - 1) || i.value.children.length > 0 || (f = i.value.parentElement) == null || f.removeChild(i.value);
  }), () => {
    if (!s.value || i.value === null) return null;
    let c = { ref: n, "data-headlessui-portal": "" };
    return S(at, { to: i.value }, D({ ourProps: c, theirProps: e, slot: {}, attrs: r, slots: t, name: "Portal" }));
  };
} }), Re = Symbol("PortalParentContext");
function jr() {
  let e = P(Re, null), t = h([]);
  function r(a) {
    return t.value.push(a), e && e.register(a), () => n(a);
  }
  function n(a) {
    let l = t.value.indexOf(a);
    l !== -1 && t.value.splice(l, 1), e && e.unregister(a);
  }
  let o = { register: r, unregister: n, portals: t };
  return [t, $({ name: "PortalWrapper", setup(a, { slots: l }) {
    return B(Re, o), () => {
      var i;
      return (i = l.default) == null ? void 0 : i.call(l);
    };
  } })];
}
let _t = Symbol("PortalGroupContext"), Br = $({ name: "PortalGroup", props: { as: { type: [Object, String], default: "template" }, target: { type: Object, default: null } }, setup(e, { attrs: t, slots: r }) {
  let n = nt({ resolveTarget() {
    return e.target;
  } });
  return B(_t, n), () => {
    let { target: o, ...a } = e;
    return D({ theirProps: a, ourProps: {}, slot: {}, attrs: t, slots: r, name: "PortalGroup" });
  };
} });
var Mr = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Mr || {});
let Ie = Symbol("DialogContext");
function fe(e) {
  let t = P(Ie, null);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, fe), r;
  }
  return t;
}
let ke = "DC8F892D-2EBD-447C-A4C8-A03058436FF4", Hr = $({ name: "Dialog", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, open: { type: [Boolean, String], default: ke }, initialFocus: { type: Object, default: null }, id: { type: String, default: null }, role: { type: String, default: "dialog" } }, emits: { close: (e) => !0 }, setup(e, { emit: t, attrs: r, slots: n, expose: o }) {
  var a, l;
  let i = (a = e.id) != null ? a : `headlessui-dialog-${J()}`, s = h(!1);
  L(() => {
    s.value = !0;
  });
  let u = !1, d = g(() => e.role === "dialog" || e.role === "alertdialog" ? e.role : (u || (u = !0, console.warn(`Invalid role [${d}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog")), v = h(0), c = qe(), f = g(() => e.open === ke && c !== null ? (c.value & F.Open) === F.Open : e.open), p = h(null), m = g(() => ae(p));
  if (o({ el: p, $el: p }), !(e.open !== ke || c !== null)) throw new Error("You forgot to provide an `open` prop to the `Dialog`.");
  if (typeof f.value != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${f.value === ke ? void 0 : e.open}`);
  let k = g(() => s.value && f.value ? 0 : 1), H = g(() => k.value === 0), O = g(() => v.value > 1), G = P(Ie, null) !== null, [ge, ve] = jr(), { resolveContainers: ee, mainTreeNodeRef: me, MainTreeNode: be } = Lr({ portals: ge, defaultContainers: [g(() => {
    var y;
    return (y = te.panelRef.value) != null ? y : p.value;
  })] }), Pe = g(() => O.value ? "parent" : "leaf"), he = g(() => c !== null ? (c.value & F.Closing) === F.Closing : !1), Oe = g(() => G || he.value ? !1 : H.value), Fe = g(() => {
    var y, _, A;
    return (A = Array.from((_ = (y = m.value) == null ? void 0 : y.querySelectorAll("body > *")) != null ? _ : []).find((C) => C.id === "headlessui-portal-root" ? !1 : C.contains(T(me)) && C instanceof HTMLElement)) != null ? A : null;
  });
  Je(Fe, Oe);
  let z = g(() => O.value ? !0 : H.value), le = g(() => {
    var y, _, A;
    return (A = Array.from((_ = (y = m.value) == null ? void 0 : y.querySelectorAll("[data-headlessui-portal]")) != null ? _ : []).find((C) => C.contains(T(me)) && C instanceof HTMLElement)) != null ? A : null;
  });
  Je(le, z), Fr({ type: "Dialog", enabled: g(() => k.value === 0), element: p, onUpdate: (y, _) => {
    if (_ === "Dialog") return R(y, { [He.Add]: () => v.value += 1, [He.Remove]: () => v.value -= 1 });
  } });
  let I = Ar({ name: "DialogDescription", slot: g(() => ({ open: f.value })) }), V = h(null), te = { titleId: V, panelRef: h(null), dialogState: k, setTitleId(y) {
    V.value !== y && (V.value = y);
  }, close() {
    t("close", !1);
  } };
  B(Ie, te);
  let Ke = g(() => !(!H.value || O.value));
  cr(ee, (y, _) => {
    y.preventDefault(), te.close(), Ft(() => _ == null ? void 0 : _.focus());
  }, Ke);
  let Xe = g(() => !(O.value || k.value !== 0));
  mt((l = m.value) == null ? void 0 : l.defaultView, "keydown", (y) => {
    Xe.value && (y.defaultPrevented || y.key === vt.Escape && (y.preventDefault(), y.stopPropagation(), te.close()));
  });
  let Qe = g(() => !(he.value || k.value !== 0 || G));
  return Sr(m, Qe, (y) => {
    var _;
    return { containers: [...(_ = y.containers) != null ? _ : [], ee] };
  }), N((y) => {
    if (k.value !== 0) return;
    let _ = T(p);
    if (!_) return;
    let A = new ResizeObserver((C) => {
      for (let De of C) {
        let ye = De.target.getBoundingClientRect();
        ye.x === 0 && ye.y === 0 && ye.width === 0 && ye.height === 0 && te.close();
      }
    });
    A.observe(_), y(() => A.disconnect());
  }), () => {
    let { open: y, initialFocus: _, ...A } = e, C = { ...r, ref: p, id: i, role: d.value, "aria-modal": k.value === 0 ? !0 : void 0, "aria-labelledby": V.value, "aria-describedby": I.value }, De = { open: k.value === 0 };
    return S(Me, { force: !0 }, () => [S($t, () => S(Br, { target: p.value }, () => S(Me, { force: !1 }, () => S(ie, { initialFocus: _, containers: ee, features: H.value ? R(Pe.value, { parent: ie.features.RestoreFocus, leaf: ie.features.All & ~ie.features.FocusLock }) : ie.features.None }, () => S(ve, {}, () => D({ ourProps: C, theirProps: { ...A, ...r }, slot: De, attrs: r, slots: n, visible: k.value === 0, features: Te.RenderStrategy | Te.Static, name: "Dialog" })))))), S(be)]);
  };
} });
$({ name: "DialogOverlay", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r }) {
  var n;
  let o = (n = e.id) != null ? n : `headlessui-dialog-overlay-${J()}`, a = fe("DialogOverlay");
  function l(i) {
    i.target === i.currentTarget && (i.preventDefault(), i.stopPropagation(), a.close());
  }
  return () => {
    let { ...i } = e;
    return D({ ourProps: { id: o, "aria-hidden": !0, onClick: l }, theirProps: i, slot: { open: a.dialogState.value === 0 }, attrs: t, slots: r, name: "DialogOverlay" });
  };
} });
$({ name: "DialogBackdrop", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, inheritAttrs: !1, setup(e, { attrs: t, slots: r, expose: n }) {
  var o;
  let a = (o = e.id) != null ? o : `headlessui-dialog-backdrop-${J()}`, l = fe("DialogBackdrop"), i = h(null);
  return n({ el: i, $el: i }), L(() => {
    if (l.panelRef.value === null) throw new Error("A <DialogBackdrop /> component is being used, but a <DialogPanel /> component is missing.");
  }), () => {
    let { ...s } = e, u = { id: a, ref: i, "aria-hidden": !0 };
    return S(Me, { force: !0 }, () => S($t, () => D({ ourProps: u, theirProps: { ...t, ...s }, slot: { open: l.dialogState.value === 0 }, attrs: t, slots: r, name: "DialogBackdrop" })));
  };
} });
let zr = $({ name: "DialogPanel", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r, expose: n }) {
  var o;
  let a = (o = e.id) != null ? o : `headlessui-dialog-panel-${J()}`, l = fe("DialogPanel");
  n({ el: l.panelRef, $el: l.panelRef });
  function i(s) {
    s.stopPropagation();
  }
  return () => {
    let { ...s } = e, u = { id: a, ref: l.panelRef, onClick: i };
    return D({ ourProps: u, theirProps: s, slot: { open: l.dialogState.value === 0 }, attrs: t, slots: r, name: "DialogPanel" });
  };
} }), Rr = $({ name: "DialogTitle", props: { as: { type: [Object, String], default: "h2" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r }) {
  var n;
  let o = (n = e.id) != null ? n : `headlessui-dialog-title-${J()}`, a = fe("DialogTitle");
  return L(() => {
    a.setTitleId(o), M(() => a.setTitleId(null));
  }), () => {
    let { ...l } = e;
    return D({ ourProps: { id: o }, theirProps: l, slot: { open: a.dialogState.value === 0 }, attrs: t, slots: r, name: "DialogTitle" });
  };
} });
function Ir(e) {
  let t = { called: !1 };
  return (...r) => {
    if (!t.called) return t.called = !0, e(...r);
  };
}
function Ne(e, ...t) {
  e && t.length > 0 && e.classList.add(...t);
}
function Ee(e, ...t) {
  e && t.length > 0 && e.classList.remove(...t);
}
var Ve = ((e) => (e.Finished = "finished", e.Cancelled = "cancelled", e))(Ve || {});
function Vr(e, t) {
  let r = ce();
  if (!e) return r.dispose;
  let { transitionDuration: n, transitionDelay: o } = getComputedStyle(e), [a, l] = [n, o].map((i) => {
    let [s = 0] = i.split(",").filter(Boolean).map((u) => u.includes("ms") ? parseFloat(u) : parseFloat(u) * 1e3).sort((u, d) => d - u);
    return s;
  });
  return a !== 0 ? r.setTimeout(() => t("finished"), a + l) : t("finished"), r.add(() => t("cancelled")), r.dispose;
}
function tt(e, t, r, n, o, a) {
  let l = ce(), i = a !== void 0 ? Ir(a) : () => {
  };
  return Ee(e, ...o), Ne(e, ...t, ...r), l.nextFrame(() => {
    Ee(e, ...r), Ne(e, ...n), l.add(Vr(e, (s) => (Ee(e, ...n, ...t), Ne(e, ...o), i(s))));
  }), l.add(() => Ee(e, ...t, ...r, ...n, ...o)), l.add(() => i("cancelled")), l.dispose;
}
function Y(e = "") {
  return e.split(/\s+/).filter((t) => t.length > 1);
}
let Ge = Symbol("TransitionContext");
var Ur = ((e) => (e.Visible = "visible", e.Hidden = "hidden", e))(Ur || {});
function Wr() {
  return P(Ge, null) !== null;
}
function qr() {
  let e = P(Ge, null);
  if (e === null) throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return e;
}
function Gr() {
  let e = P(Ye, null);
  if (e === null) throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return e;
}
let Ye = Symbol("NestingContext");
function Le(e) {
  return "children" in e ? Le(e.children) : e.value.filter(({ state: t }) => t === "visible").length > 0;
}
function Tt(e) {
  let t = h([]), r = h(!1);
  L(() => r.value = !0), M(() => r.value = !1);
  function n(a, l = q.Hidden) {
    let i = t.value.findIndex(({ id: s }) => s === a);
    i !== -1 && (R(l, { [q.Unmount]() {
      t.value.splice(i, 1);
    }, [q.Hidden]() {
      t.value[i].state = "hidden";
    } }), !Le(t) && r.value && (e == null || e()));
  }
  function o(a) {
    let l = t.value.find(({ id: i }) => i === a);
    return l ? l.state !== "visible" && (l.state = "visible") : t.value.push({ id: a, state: "visible" }), () => n(a, q.Unmount);
  }
  return { children: t, register: o, unregister: n };
}
let xt = Te.RenderStrategy, Ue = $({ props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(e, { emit: t, attrs: r, slots: n, expose: o }) {
  let a = h(0);
  function l() {
    a.value |= F.Opening, t("beforeEnter");
  }
  function i() {
    a.value &= ~F.Opening, t("afterEnter");
  }
  function s() {
    a.value |= F.Closing, t("beforeLeave");
  }
  function u() {
    a.value &= ~F.Closing, t("afterLeave");
  }
  if (!Wr() && fr()) return () => S(St, { ...e, onBeforeEnter: l, onAfterEnter: i, onBeforeLeave: s, onAfterLeave: u }, n);
  let d = h(null), v = g(() => e.unmount ? q.Unmount : q.Hidden);
  o({ el: d, $el: d });
  let { show: c, appear: f } = qr(), { register: p, unregister: m } = Gr(), k = h(c.value ? "visible" : "hidden"), H = { value: !0 }, O = J(), G = { value: !1 }, ge = Tt(() => {
    !G.value && k.value !== "hidden" && (k.value = "hidden", m(O), u());
  });
  L(() => {
    let z = p(O);
    M(z);
  }), N(() => {
    if (v.value === q.Hidden && O) {
      if (c.value && k.value !== "visible") {
        k.value = "visible";
        return;
      }
      R(k.value, { hidden: () => m(O), visible: () => p(O) });
    }
  });
  let ve = Y(e.enter), ee = Y(e.enterFrom), me = Y(e.enterTo), be = Y(e.entered), Pe = Y(e.leave), he = Y(e.leaveFrom), Oe = Y(e.leaveTo);
  L(() => {
    N(() => {
      if (k.value === "visible") {
        let z = T(d);
        if (z instanceof Comment && z.data === "") throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
      }
    });
  });
  function Fe(z) {
    let le = H.value && !f.value, I = T(d);
    !I || !(I instanceof HTMLElement) || le || (G.value = !0, c.value && l(), c.value || s(), z(c.value ? tt(I, ve, ee, me, be, (V) => {
      G.value = !1, V === Ve.Finished && i();
    }) : tt(I, Pe, he, Oe, be, (V) => {
      G.value = !1, V === Ve.Finished && (Le(ge) || (k.value = "hidden", m(O), u()));
    })));
  }
  return L(() => {
    oe([c], (z, le, I) => {
      Fe(I), H.value = !1;
    }, { immediate: !0 });
  }), B(Ye, ge), gr(g(() => R(k.value, { visible: F.Open, hidden: F.Closed }) | a.value)), () => {
    let { appear: z, show: le, enter: I, enterFrom: V, enterTo: te, entered: Ke, leave: Xe, leaveFrom: Qe, leaveTo: y, ..._ } = e, A = { ref: d }, C = { ..._, ...f.value && c.value && pe.isServer ? { class: ne([r.class, _.class, ...ve, ...ee]) } : {} };
    return D({ theirProps: C, ourProps: A, slot: {}, slots: n, attrs: r, features: xt, visible: k.value === "visible", name: "TransitionChild" });
  };
} }), Yr = Ue, St = $({ inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(e, { emit: t, attrs: r, slots: n }) {
  let o = qe(), a = g(() => e.show === null && o !== null ? (o.value & F.Open) === F.Open : e.show);
  N(() => {
    if (![!0, !1].includes(a.value)) throw new Error('A <Transition /> is used but it is missing a `:show="true | false"` prop.');
  });
  let l = h(a.value ? "visible" : "hidden"), i = Tt(() => {
    l.value = "hidden";
  }), s = h(!0), u = { show: a, appear: g(() => e.appear || !s.value) };
  return L(() => {
    N(() => {
      s.value = !1, a.value ? l.value = "visible" : Le(i) || (l.value = "hidden");
    });
  }), B(Ye, i), B(Ge, u), () => {
    let d = ft(e, ["show", "appear", "unmount", "onBeforeEnter", "onBeforeLeave", "onAfterEnter", "onAfterLeave"]), v = { unmount: e.unmount };
    return D({ ourProps: { ...v, as: "template" }, theirProps: {}, slot: {}, slots: { ...n, default: () => [S(Yr, { onBeforeEnter: () => t("beforeEnter"), onAfterEnter: () => t("afterEnter"), onBeforeLeave: () => t("beforeLeave"), onAfterLeave: () => t("afterLeave"), ...r, ...v, ...d }, n.default)] }, attrs: {}, features: xt, visible: l.value === "visible", name: "Transition" });
  };
} });
const Kr = /* @__PURE__ */ b("div", { class: "fixed inset-0 bg-gray-500/75 transition-opacity" }, null, -1), Xr = { class: "fixed inset-0 z-10 overflow-y-auto" }, Qr = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }, Zr = { class: "bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4 dark:bg-zinc-800" }, Jr = { class: "sm:flex sm:items-start" }, en = { class: "mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left" }, tn = { class: "mt-2" }, rn = { class: "text-sm text-gray-500 dark:text-zinc-200" }, nn = { class: "bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 dark:bg-zinc-700" }, oo = /* @__PURE__ */ $({
  __name: "TEModal",
  props: {
    open: { type: Boolean }
  },
  emits: ["update:open"],
  setup(e) {
    return (t, r) => (w(), lt(U(St), {
      as: "template",
      show: t.open
    }, {
      default: re(() => [
        K(U(Hr), {
          as: "div",
          class: "relative z-10",
          onClose: r[0] || (r[0] = (n) => t.$emit("update:open", !1))
        }, {
          default: re(() => [
            K(U(Ue), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: re(() => [
                Kr
              ]),
              _: 1
            }),
            b("div", Xr, [
              b("div", Qr, [
                K(U(Ue), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: re(() => [
                    K(U(zr), { class: "relative overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg dark:bg-zinc-800" }, {
                      default: re(() => [
                        b("div", Zr, [
                          b("div", Jr, [
                            b("div", en, [
                              K(U(Rr), {
                                as: "h3",
                                class: "text-base font-semibold leading-6 text-gray-900 dark:text-zinc-50"
                              }, {
                                default: re(() => [
                                  x(t.$slots, "title")
                                ]),
                                _: 3
                              }),
                              b("div", tn, [
                                b("p", rn, [
                                  x(t.$slots, "default")
                                ])
                              ])
                            ])
                          ])
                        ]),
                        b("div", nn, [
                          x(t.$slots, "actions")
                        ])
                      ]),
                      _: 3
                    })
                  ]),
                  _: 3
                })
              ])
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), on = {}, an = {
  "aria-label": "assertive",
  class: "pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6"
}, ln = /* @__PURE__ */ b("div", {
  id: "te-notifications",
  class: "flex w-full flex-col items-center space-y-4 sm:items-end"
}, null, -1), sn = [
  ln
];
function un(e, t) {
  return w(), E("div", an, sn);
}
const dn = /* @__PURE__ */ de(on, [["render", un]]), cn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dn
}, Symbol.toStringTag, { value: "Module" }));
function pn(e, t) {
  return w(), E("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    b("path", { d: "M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" })
  ]);
}
const fn = {
  key: 0,
  class: "dark:bg-zinc-800 pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black/5 dark:ring-zinc-700"
}, gn = { class: "p-4" }, vn = { class: "flex items-start" }, mn = {
  key: 0,
  class: "mr-3 shrink-0"
}, bn = { class: "w-0 flex-1" }, hn = { class: "text-sm font-medium text-zinc-900 dark:text-white" }, yn = {
  key: 0,
  class: "mt-1 text-sm text-zinc-500 dark:text-zinc-100"
}, wn = {
  key: 1,
  class: "mt-3 flex space-x-7"
}, kn = {
  key: 1,
  class: "ml-4 flex shrink-0"
}, rt = /* @__PURE__ */ $({
  __name: "TENotification",
  props: {
    show: { type: Boolean },
    closeable: { type: Boolean },
    title: {},
    description: {},
    autoClose: { type: Boolean },
    color: {}
  },
  emits: ["update:show"],
  setup(e, { emit: t }) {
    const r = e, n = t, o = h(!1);
    let a;
    return L(() => {
      o.value = !0, Dt(() => {
        clearTimeout(a);
      });
    }), setTimeout(() => {
      n("update:show", !1);
    }, 2500), N(() => {
      r.autoClose && r.show ? typeof window < "u" && (a = window.setTimeout(() => {
        n("update:show", !1);
      }, 2500)) : a && clearTimeout(a);
    }), (l, i) => o.value ? (w(), lt(at, {
      key: 0,
      to: "#te-notifications"
    }, [
      K(At, {
        "enter-active-class": "transition duration-300 ease-out transform",
        "enter-from-class": "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
        "enter-to-class": "translate-y-0 opacity-100 sm:translate-x-0",
        "leave-active-class": "transition duration-100 ease-in",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }),
      l.show ? (w(), E("div", fn, [
        l.autoClose ? (w(), E("div", {
          key: 0,
          class: ne(["te-notification-progress h-1", {
            "bg-green-500": l.color === "green",
            "bg-red-500": l.color === "red",
            "bg-primary-500": !l.color
          }]),
          style: { "animation-duration": "2500ms" }
        }, null, 2)) : j("", !0),
        b("div", gn, [
          b("div", vn, [
            l.$slots.icon ? (w(), E("div", mn, [
              x(l.$slots, "icon")
            ])) : j("", !0),
            b("div", bn, [
              b("p", hn, _e(l.title), 1),
              l.description || l.$slots.default ? (w(), E("p", yn, [
                x(l.$slots, "default", {}, () => [
                  ot(_e(l.description), 1)
                ])
              ])) : j("", !0),
              l.$slots.actions ? (w(), E("div", wn, [
                x(l.$slots, "actions")
              ])) : j("", !0)
            ]),
            l.closeable ? (w(), E("div", kn, [
              b("button", {
                class: "size-4",
                type: "submit",
                onClick: i[0] || (i[0] = (s) => l.$emit("update:show", !1))
              }, [
                K(U(pn), { class: "dark:text-white" })
              ])
            ])) : j("", !0)
          ])
        ])
      ])) : j("", !0)
    ])) : j("", !0);
  }
}), ao = $({
  name: "TEFlashNotification",
  components: { TENotification: rt },
  props: {
    show: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      default: void 0
    },
    autoClose: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["update:show"],
  // eslint-disable-next-line vue/component-api-style
  render() {
    return S(rt, {
      show: this.show,
      "onUpdate:show": (e) => this.$emit("update:show", e),
      title: this.title,
      description: this.description,
      autoClose: !0
    });
  }
}), En = {}, $n = { class: "max-w-8xl bg-white w-full rounded-md shadow-xl dark:bg-zinc-800" }, _n = { class: "p-4 dark:border-zinc-700 border-b-2" }, Tn = { class: "text-2xl font-medium dark:text-gray-50" }, xn = {
  key: 0,
  class: "text-sm text-gray-500 dark:text-gray-300"
};
function Sn(e, t) {
  return w(), E("div", $n, [
    b("div", _n, [
      b("h2", Tn, [
        x(e.$slots, "title")
      ]),
      e.$slots.subtitle ? (w(), E("p", xn, [
        x(e.$slots, "subtitle")
      ])) : j("", !0)
    ]),
    b("div", null, [
      x(e.$slots, "default")
    ])
  ]);
}
const Ln = /* @__PURE__ */ de(En, [["render", Sn]]), Pn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ln
}, Symbol.toStringTag, { value: "Module" })), On = {}, Fn = { class: "md:grid md:grid-cols-2 hover:bg-gray-50 md:space-y-0 space-y-1 p-4 border-b dark:border-zinc-700 dark:hover:bg-zinc-700" }, Dn = { class: "text-gray-600 dark:text-gray-200" }, An = { class: "dark:text-white" };
function Cn(e, t) {
  return w(), E("div", Fn, [
    b("p", Dn, [
      x(e.$slots, "name")
    ]),
    b("p", An, [
      x(e.$slots, "default")
    ])
  ]);
}
const Nn = /* @__PURE__ */ de(On, [["render", Cn]]), jn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Nn
}, Symbol.toStringTag, { value: "Module" })), Bn = ["model-value"], lo = /* @__PURE__ */ $({
  __name: "TESelect",
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    return (t, r) => (w(), E("select", {
      "model-value": t.modelValue,
      class: "block w-full appearance-none rounded border border-gray-300 bg-white px-4 py-2 pr-8 leading-tight text-gray-700 focus:border-blue-500 focus:bg-white focus:outline-none dark:border-gray-500 dark:bg-zinc-800 dark:text-white dark:ring-primary-600 dark:ring-offset-gray-700 dark:focus:border-primary-600 dark:focus:bg-zinc-800 dark:focus:ring-primary-600 dark:focus:ring-offset-gray-700",
      "onUpdate:modelValue": r[0] || (r[0] = (n) => t.$emit("update:modelValue", n))
    }, [
      x(t.$slots, "default")
    ], 8, Bn));
  }
}), Mn = {}, Hn = { class: "text-base font-semibold leading-7 text-gray-900 dark:text-gray-50" }, zn = { class: "mt-1 text-sm leading-6 text-gray-600 dark:text-gray-300" };
function Rn(e, t) {
  return w(), E(Se, null, [
    b("h2", Hn, [
      x(e.$slots, "header")
    ]),
    b("p", zn, [
      x(e.$slots, "default")
    ])
  ], 64);
}
const In = /* @__PURE__ */ de(Mn, [["render", Rn]]), Vn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: In
}, Symbol.toStringTag, { value: "Module" })), Un = { class: "flex items-center justify-between px-4 py-3 sm:px-6" }, Wn = { class: "flex flex-1 justify-between sm:hidden" }, qn = ["href"], Gn = ["href"], Yn = { class: "hidden sm:block" }, Kn = {
  class: "isolate inline-flex -space-x-px rounded-md shadow-sm",
  "aria-label": "Pagination"
}, Xn = ["href", "innerHTML"], Qn = "first:rounded-l-md last:rounded-r-md relative z-10 inline-flex items-center dark:bg-primary-800 bg-primary-600 px-4 py-2 text-sm font-semibold text-white focus:z-20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600", Zn = "first:rounded-l-md last:rounded-r-md relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 dark:bg-zinc-800 dark:text-white dark:ring-primary-600 dark:hover:bg-primary-600 dark:focus:bg-primary-600 dark:focus:ring-primary-600 dark:focus:ring-offset-gray-700 dark:focus:outline-primary-600", io = /* @__PURE__ */ $({
  __name: "TEPagination",
  props: {
    pagination: {}
  },
  setup(e) {
    return (t, r) => (w(), E("div", Un, [
      b("div", Wn, [
        b("a", {
          href: t.pagination.links[0].url ?? void 0,
          class: "bg-primary-500 dark:bg-primary-800 hover:bg-primary-600 focus:bg-primary-600 hover:bg-primary-600 focus:bg-primary-600 active:bg-primary-700 hover:dark:bg-primary-700 inline-block rounded-full px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-white transition duration-150 ease-in-out focus:outline-none focus:ring-0"
        }, "Vorherige Seite", 8, qn),
        b("a", {
          href: t.pagination.links[t.pagination.links.length - 1].url ?? "#",
          class: "bg-primary-500 dark:bg-primary-800 hover:bg-primary-600 focus:bg-primary-600 hover:bg-primary-600 focus:bg-primary-600 active:bg-primary-700 hover:dark:bg-primary-700 inline-block rounded-full px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-white transition duration-150 ease-in-out focus:outline-none focus:ring-0"
        }, "Nächste", 8, Gn)
      ]),
      b("div", Yn, [
        b("nav", Kn, [
          (w(!0), E(Se, null, Ct(t.pagination.links, (n) => (w(), E("a", {
            key: n.label,
            href: n.url ?? void 0,
            class: ne(["whitespace-nowrap", n.active ? Qn : Zn]),
            innerHTML: n.label
          }, null, 10, Xn))), 128))
        ])
      ])
    ]));
  }
}), so = {
  install: (e) => {
    e.component("TEButton", jt), e.component("TEBadge", () => import("./TEBadge-BjV_LW9q.js")), e.component("TEModal", () => import("./TEModal-Dubmh9rC.js")), e.component("TECard", () => Promise.resolve().then(() => Ut)), e.component(
      "TETopLabelLayout",
      () => import("./TETopLabelLayout-BYyBASiB.js")
    ), e.component(
      "TETextInput",
      () => import("./TETextInput-Diz4WxrW.js")
    ), e.component(
      "TENotificationHost",
      () => Promise.resolve().then(() => cn)
    ), e.component(
      "TENotification",
      () => import("./TENotification-D1JMMiaO.js")
    ), e.component(
      "TEFlashNotification",
      () => import("./TEFlashNotification-DIL_n4an.js")
    ), e.component(
      "TEDescriptionList",
      () => Promise.resolve().then(() => Pn)
    ), e.component(
      "TEDescriptionListItem",
      () => Promise.resolve().then(() => jn)
    ), e.component("TESelect", () => import("./TESelect-B2aYpxAH.js")), e.component(
      "TEFormSectionHeader",
      () => Promise.resolve().then(() => Vn)
    ), e.component(
      "TEPagination",
      () => import("./TEPagination-B2v-6l8u.js")
    );
  }
};
export {
  ro as TEBadge,
  jt as TEButton,
  Vt as TECard,
  Ln as TEDescriptionList,
  Nn as TEDescriptionListItem,
  ao as TEFlashNotification,
  In as TEFormSectionHeader,
  oo as TEModal,
  rt as TENotification,
  dn as TENotificationHost,
  io as TEPagination,
  lo as TESelect,
  eo as TETextInput,
  to as TETopLabelLayout,
  so as default
};
